var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"draggableContainer",staticClass:"ponto",attrs:{"id":'ponto'+_vm.tipo + _vm.ponto.id}},[_c('div',{ref:'ponto' + _vm.ponto.id,staticClass:"draggable",on:{"mousedown":_vm.dragMouseDown}},[_c('span',{staticClass:"dot"})])])}
var staticRenderFns = []

export { render, staticRenderFns }